import React from "react";
import { MainProps } from "../../entities/Main";
import { getStylesFromTenant } from "../../utils/tenant";

const Main: React.FC<MainProps> = ({ credentials, children }: MainProps) => (
  <main style={getStylesFromTenant(credentials.webshopDesigns)}>
    {children}
  </main>
);

export default Main;
